import { render } from "./MemberAssign.vue?vue&type=template&id=59ea2106"
import script from "./MemberAssign.vue?vue&type=script&lang=js"
export * from "./MemberAssign.vue?vue&type=script&lang=js"

import "./MemberAssign.vue?vue&type=style&index=0&id=59ea2106&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__